import React from "react";
import Toggle from "react-toggle";
import "./multi-select-date.component.sass"
import MvwIcon from "Generic/MvIcon";
import { DropdownOption } from "Interfaces/MultiSelectDate";



type Props = {
  options : DropdownOption[]
  onChangeFilter: (e: any) => void;
  label: string;
}

type MultiSelectDateStates = {
  open: boolean;
  options : DropdownOption[];
}



class MultiSelectDate extends React.Component<Props, MultiSelectDateStates> {

  constructor(props: Props) {
    super(props);
    this.state = {
      open: false,
      options: []
    }
    this.toggleDropdown = this.toggleDropdown.bind(this)
    this.toggleCheckbox = this.toggleCheckbox.bind(this)
    this.reset = this.reset.bind(this)
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  
  container = React.createRef<HTMLDivElement>();

  static getDerivedStateFromProps(props: Props, state: MultiSelectDateStates) {


    if (props.options !== state.options) {
      return {
        ...state,
        options: props.options
      }

    }
    return null

  }

  componentDidMount(){
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount(){
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleClickOutside(event: any){
    if(this.container.current && !this.container.current.contains(event.target)){
      this.setState({open: false})
    }
  }



  toggleDropdown() {
    const { open } = this.state;
    this.setState({
      open: !open
    })
  }

  reset() {
    const { options } = this.state;
    const items = options.map((option) => {
      option.checked = false;

      return option;
    })
    this.setState({
      options: items
    });
    this.props.onChangeFilter(items);
  }

  toggleCheckbox(item: DropdownOption) {
    const { options } = this.state;
   const items =  options.map((option)=>{
     if(item.year === option.year){
       option.checked = !option.checked;
     }
     return option;
   })
    this.setState({
      options: items
    });
   this.props.onChangeFilter(items);

  }
  render() {
    const { options, open } = this.state;

    return (<div className="multiSelect" ref={this.container}>
      <div className="multi-select-wrapper">
        <button className="multi-select-dropdown" onClick={this.toggleDropdown}>
          <span className="name">{this.props.label}</span>
          <span className="dropdown-icon"> 
            { !open && <MvwIcon height="1.5rem" width="10px" icon="angleDown" color="#FFFFFF"/>}
            { open && <MvwIcon height="1.5rem" width="10px" icon="angleUp" color="#FFFFFF"/>}
          </span>
        </button>
        {open && <div className="multi-select-check-boxes">
          <div className="years-items">
          {options && options.length && options.map((item) => {
            return <label>  <input type="checkbox" checked={item.checked} onClick={()=>{this.toggleCheckbox(item)}} />
              <span className="value">{item.year} </span>
            </label>
          }) || null}
          </div>
          <div className="reset" onClick={()=> {this.reset()}}> <a> Reset </a></div>
        </div>}
      </div>
    </div>
    );
  }
}
export default MultiSelectDate;
